<template>
  <section>
    <Toolbar />
    <div
      class="
        d-flex
        flex-column
        justify-center
        align-center
        ma-0
        pa-0
        mt-md-5 mt-lg-5 mt-xl-5
        mx-5
      "
    >
      <!-- <IconoHeader icono="draw" /> -->
      <v-row justify="center" class="ma-0 pa-0">
        <v-col cols="10" class="ma-0 pa-0">
          <h3 class="texto-titulo text-center font-weight-bold">
            Aceptación de contratos
          </h3>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-5">
        <v-col cols="12" class="ma-0 pa-0">
          <p
            class="text-body-2 text-center grey--text text--darken-2 ma-0 mx-3"
          >
            Ingresa el código de verificación que hemos enviado a tu celular.
          </p>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-2">
        <v-col cols="11" xs="11" sm="6" md="6" lg="6" xl="6" class="ma-0 pa-0">
          <v-otp-input
            v-model="otp"
            class="seccion-otp"
            length="6"
            type="number"
            @keydown="verificarOTPEsNumerico"
            @input="verificarOtpEsValido"
            autocomplete="off"
          ></v-otp-input>
          <div class="d-flex flex-row justify-center align-center pa-0">
            <span class="text-body-2 grey--text text--darken-2">
              ¿No recibiste código?
            </span>
            <v-btn
              text
              color="primary"
              @click="reenviarOtp"
              :loading="cargandoReenvio"
              :disabled="cargandoReenvio || contador > 0"
              >{{ mensajeReenviar }}</v-btn
            >
          </div>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mx-3">
        <v-col cols="12" class="ma-0 pa-0">
          <v-alert
            dense
            text
            type="info"
            :icon="false"
            class="text-center font-weight-black ma-0"
          >
            Este código es necesario para validar que seas tu quien firma y
            acepta los contratos del crédito.
          </v-alert>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-5">
        <v-col
          cols="12"
          class="ma-0 pa-0 d-flex flex-column justify-center align-center"
        >
          <v-btn fab dark color="primary" @click="verContrato">
            <v-icon dark> mdi-file-document-multiple </v-icon>
          </v-btn>
          <p class="text-body-2 text-center font-weight-medium mb-0">
            Ver contratos
          </p>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0">
        <v-col
          cols="10"
          class="ma-0 pa-0 d-flex flex-column justify-center align-center"
        >
          <v-checkbox v-model="aceptaFirmar" :disabled="!esOtpFirmaValido">
            <template v-slot:label>
              <span class="text-center">
                Despúes de haber leído los términos del contrato, expreso mi
                consentimiento al estar de acuerdo con ellos.
              </span>
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="11" xs="11" sm="11" md="8" lg="8" xl="8" class="ma-0 pa-0">
          <v-checkbox
            v-model="sonTerminosBuroConfirmados"
            class="ma-0 pa-0"
            :disabled="!esOtpFirmaValido"
          >
            <template v-slot:label>
              <span class="text-center">
                <!-- Confirmo que este código se utilizará para la autorización por
                medios electrónicos de la consulta de mi -->
                Confirmo con este código la consulta de mi
                <a @click="verTerminos">Buró de Crédito</a>
              </span>
            </template>
          </v-checkbox>
        </v-col>
      </v-row>
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-10 mt-xs-10 mt-sm-10 mt-md-4 mt-lg-4 mt-xl-4"
        v-if="esSPD()"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <v-dialog v-model="dialogEjecutivo" width="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="align-self-center"
                color="primary"
                v-bind="attrs"
                v-on="on"
                elevation="3"
                :disabled="
                  !(
                    esOtpFirmaValido &&
                    aceptaFirmar &&
                    sonTerminosBuroConfirmados
                  ) || cargandoCreacionSolicitud
                "
                >ACEPTAR<v-icon right light>mdi-arrow-right</v-icon></v-btn
              >
              <!-- <v-btn
                class="align-self-center"
                color="primary"
                v-bind="attrs"
                v-on="on"
                elevation="3"
                @click="noInteresado"
                >NO INTERESADO DE MOMENTO<v-icon right light
                  >mdi-arrow-left</v-icon
                ></v-btn
              > -->
            </template>
            <v-card class="ma-0 pa-0" cols="5">
              <v-card-title>Antes de continuar...</v-card-title>
              <v-card-subtitle class="text-body text-center mt-2 py-0"
                >Si recibiste ayuda de un asesor de Caja Morelia durante tu
                solicitud de crédito, solicitale el folio de atención e
                ingresalo aqui:
                <!-- <v-chip color="green" outlined>{{ celularOferta }} </v-chip> -->
              </v-card-subtitle>
              <!-- <v-card-subtitle class="text-body text-center mt-2 py-0"
                >De ser así solicita su número a tu asesor
                e ingresalo aqui :</v-card-subtitle
              > -->
              <v-row justify="center" no-gutters>
                <v-col
                  cols="12"
                  xs="12"
                  sm="12"
                  md="8"
                  lg="8"
                  xl="8"
                  class="
                    mt-4
                    ma-0
                    pa-0
                    d-flex
                    flex-column
                    justify-center
                    align-center
                  "
                >
                  <v-text-field
                    style="max-width: 50%"
                    outlined
                    type="number"
                    v-model="numusuarioEjecutivo"
                    label="Folio asesor"
                  ></v-text-field>
                  <v-btn
                    style="top: -15px"
                    @click="firmarConFolio"
                    :loading="cargandoCreacionSolicitud"
                    :disabled="
                      cargandoCreacionSolicitud || numusuarioEjecutivo == ''
                    "
                    elevation="2"
                    color="primary"
                  >
                    Registrar con folio
                  </v-btn>
                </v-col>
              </v-row>
              <v-card-subtitle>
                Si no recibiste ninguna ayuda dale clic a REGISTRAR:
              </v-card-subtitle>
              <v-card-actions class="d-flex flex-row justify-end">
                <v-btn
                  @click="firmar"
                  :loading="cargandoCreacionSolicitud"
                  :disabled="
                    cargandoCreacionSolicitud || !numusuarioEjecutivo == ''
                  "
                  elevation="2"
                  color="primary"
                >
                  Registrar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0" v-else>
        <v-col
          cols="10"
          class="ma-0 pa-0 d-flex flex-column justify-center align-center"
        >
          <v-btn
            color="primary"
            elevation="2"
            @click="firmar"
            :loading="cargandoCreacionSolicitud"
            :disabled="
              !(
                esOtpFirmaValido &&
                aceptaFirmar &&
                sonTerminosBuroConfirmados
              ) || cargandoCreacionSolicitud
            "
            >Aceptar<v-icon right light>mdi-arrow-right</v-icon></v-btn
          >
          <p
            v-if="cargandoCreacionSolicitud"
            class="
              mt-2
              font-weight-bold
              text-center text-body-2
              grey--text
              text--darken-2
            "
          >
            Espere mientras registramos su solicitud....
          </p>
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Toolbar from '@/components/compartidos/Toolbar.vue'
import OtpService from '@/servicios/otp'
import CreditoService from '@/servicios/credito'
import PersonaService from '@/servicios/persona'
import {
  KEYS_VALIDAS_OTP,
  ALERTA_ERROR,
  ID_PRODUCTO_CREDITO_SPLUS,
} from '@/utilidades/utilidades'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'

export default {
  name: 'AceptacionContratos',
  components: {
    Toolbar,
  },
  mixins: [InsertaLogMixin],
  data: () => ({
    cargandoReenvio: false,
    cargandoValidacion: false,
    cargandoCreacionSolicitud: false,
    contador: 0,
    interval: null,
    dialogEjecutivo: false,
    numusuarioEjecutivo: '',
    credito: '',
  }),
  watch: {
    otp(nuevoOtp) {
      if (nuevoOtp.length < 6) {
        this.AceptaFirmar = false
      }
    },
  },
  mounted() {
    this.InsertaLog()
  },
  created() {
    this.$store.commit('ESTABLECER_LAYOUT', 'Layout')
    this.contador = 80
    this.credito = this.$store.getters['credito/obtenerCredito']
    this.interval = setInterval(() => {
      if (this.contador <= 0) {
        clearInterval(this.interval)
      }
      this.contador -= 1
    }, 1000)
  },
  computed: {
    mensajeReenviar() {
      return this.contador <= 0 ? 'Reenviar código' : 'Espere  ' + this.contador
    },
    otp: {
      get() {
        return this.obtenerOtpFirma
      },
      set(value) {
        this.actualizaOTP({ otpFirma: value })
      },
    },
    esOtpFirmaValido: {
      get() {
        return this.obtenerEsOtpFirmaValido
      },
      set(value) {
        this.setEsOtpFirmaValido(value)
      },
    },
    aceptaFirmar: {
      get() {
        return this.obtenerAceptaFirmar
      },
      set(value) {
        this.setAceptaFirmar(value)
        this.$gtag.event('aceptoFirma', {
          event_category: 'change_in_window',
          event_label: 'Acepto la firma electronica',
          value: 1,
        })
        this.InsertaLog({ notas: 'Acepto la firma electronica' })
      },
    },
    sonTerminosBuroConfirmados: {
      get() {
        return this.obtenerSonTerminosBuroConfirmados
      },
      set(value) {
        this.setSonTerminosBuroConfirmados(value)
      },
    },
    esPermitidoContinuar() {
      if (
        this.otp.length === 6 &&
        Number.isInteger(parseInt(this.otp)) &&
        this.AceptaFirmar &&
        this.sonTerminosBuroConfirmados
      ) {
        return true
      } else {
        return false
      }
    },
    ...mapGetters({
      obtenerOtpFirma: 'credito/obtenerOtpFirma',
      obtenerEsOtpFirmaValido: 'credito/obtenerEsOtpFirmaValido',
      obtenerAceptaFirmar: 'credito/obtenerAceptaFirmar',
      obtenerSonTerminosBuroConfirmados:
        'credito/obtenerSonTerminosBuroConfirmados',
      obtenerCredito: 'credito/obtenerCredito',
    }),
  },
  methods: {
    esSPD() {
      return this.credito.tipoCredito == ID_PRODUCTO_CREDITO_SPLUS
    },
    verTerminos() {
      this.$router.push('/confirmar-terminos-buro')
    },
    actualizaOTP() {
      this.$store.dispatch('credito/actualizaOtpFirma', { otpFirma: this.otp })
      return true
    },
    verContrato() {
      this.$gtag.event('abreContrato', {
        event_category: 'change_in_window',
        event_label: 'Se abrio el contrato',
        value: 1,
      })
      this.InsertaLog({ notas: 'Se abrio el contrato' })
      this.$router.push('/contrato')
    },
    verificarOTPEsNumerico(event) {
      if (!KEYS_VALIDAS_OTP.includes(event.key)) {
        event.preventDefault()
      }
    },
    firmar() {
      this.InsertaLog({ notas: 'Firma normal' })
      if (!(this.esOtpFirmaValido && this.aceptaFirmar)) {
        return
      }

      this.$router.push('CanvasFirmaUsuario')

      //this.crearSolicitud()
    },
    firmarConFolio() {
      this.InsertaLog({ notas: 'Ingreso folio: ' + this.numusuarioEjecutivo })
      if (!(this.esOtpFirmaValido && this.aceptaFirmar)) {
        return
      }
      this.$store.dispatch(
        'credito/establecerNumUsuarioApoyo',
        parseInt(this.numusuarioEjecutivo)
      )
      this.firmar()
      //this.crearSolicitud()
    },
    async reenviarOtp() {
      this.contador = 80
      this.$store.dispatch('persona/establecerIntentosEnviarOTP')
      this.interval = setInterval(() => {
        if (this.contador <= 0) {
          clearInterval(this.interval)
        }
        this.contador -= 1
      }, 1000)
      let result
      this.otp = ''
      const reenviarOtpRequest =
        this.$store.getters['persona/obtenerEnviarOtpRequest']
      try {
        this.cargandoReenvio = true
        result = await OtpService.ReenviarOtp(reenviarOtpRequest)
        if (result.data.Codigo != 200 && result.data.Modelo != true) {
          this.enviarAlertaError(
            result.data.Mensaje,
            ALERTA_ERROR.tiempo,
            ALERTA_ERROR.visible
          )
        }
        this.cargandoReenvio = false
      } catch (error) {
        this.enviarAlertaError(
          ALERTA_ERROR.mensaje,
          ALERTA_ERROR.tiempo,
          ALERTA_ERROR.visible
        )
        this.cargandoReenvio = false
      }
    },
    async validarOtp() {
      let esOtpCorrecto = false
      const validaOtpRequest =
        this.$store.getters['persona/obtenerValidaOtpFirmaRequest']
      let result
      try {
        this.cargandoValidacion = true
        result = await OtpService.ValidaOtp(validaOtpRequest)
        if (result.data.Codigo == 200 && result.data.Estado == true) {
          esOtpCorrecto = true
        } else {
          this.enviarAlertaError({
            mensaje: result.data.Mensaje,
            tiempo: ALERTA_ERROR.tiempo,
            visibilidad: ALERTA_ERROR.visible,
          })
        }
        this.cargandoValidacion = false
      } catch {
        this.enviarAlertaError({
          mensaje: ALERTA_ERROR.mensaje,
          tiempo: ALERTA_ERROR.tiempo,
          visibilidad: ALERTA_ERROR.visible,
        })
        this.cargandoValidacion = false
      }
      return esOtpCorrecto
    },
    async verificarOtpEsValido() {
      if (this.otp.length === 6) {
        const esOtpCorrecto = await this.validarOtp()
        if (esOtpCorrecto) {
          this.esOtpFirmaValido = true
        }
      }
    },
    async crearSolicitud() {
      this.cargandoCreacionSolicitud = true
      let result
      const crearSolicitudRequest =
        this.$store.getters['credito/obtenerSolicitudDigitalRequest']
      try {
        if (this.$store.getters['credito/obtenerAplicaDevolucionMonto']) {
          result = await CreditoService.actualizaMontoSolicitudDigital(
            crearSolicitudRequest
          )
        } else {
          result = await CreditoService.insertarSolicitudDigital(
            crearSolicitudRequest
          )
        }
        if (result.data.Codigo == 200 && result.data.Estado == true) {
          //Se comenta porque los documentos se suben al momento de tomar las fotos

          // const id_solicitud = result.data.Modelo.IdSolicitud
          // let documentos =
          //   this.$store.getters[
          //     'personaDocumentos/obtenerDocumentosSolicitudDigital'
          //   ]
          // // console.log(result, documentos)
          // const promesas = []
          // // console.log('les docs a subir', documentos)
          // for (const documento of documentos) {
          //   documento.id_solicitud = id_solicitud
          //   let documentoArr = []
          //   documentoArr.push(documento)
          //   const resultado = CreditoService.insertaDocumentos(documentoArr)
          //   promesas.push(resultado)
          // }

          // const resultados = await Promise.all(promesas)
          // for (const resultado of resultados) {
          //   if (resultado.data.Codigo != 200) {
          //     console.error('Ha ocurrido un error al cargar documentos')
          //     // return
          //   }
          // }

          let resultadoActualizacionPersona
          this.$store.dispatch(
            'personaDocumentos/insertarComprobante',
            result.data.Modelo.Comprobante
          )
          const persona = this.$store.getters['persona/obtenerPersona']
          if (persona.tipoPersona == 2) {
            resultadoActualizacionPersona =
              await PersonaService.actualizarDomicilioProspecto(persona)
            if (
              resultadoActualizacionPersona.data.Codigo == 200 &&
              resultadoActualizacionPersona.data.Estado == true
            ) {
              this.$store.dispatch('credito/actualizarConfirmacion', false)
              this.$store.dispatch('credito/actualizarFinalizado', true)
              this.$router.push('terminacion')
              this.cargandoCreacionSolicitud = false
            } else {
              this.enviarAlertaError({
                mensaje:
                  'Ha ocurrido un error al procesar tu solicitud. Por favor, intente acceder de nuevo al link que recibió vía Whatsapp y reinicie el proceso.',
                tiempo: ALERTA_ERROR.tiempo,
                visibilidad: ALERTA_ERROR.visible,
              })
              this.cargandoCreacionSolicitud = false
            }
          } else {
            this.$store.dispatch('credito/actualizarConfirmacion', false)
            this.$store.dispatch('credito/actualizarFinalizado', true)
            this.$router.push('terminacion')
            this.cargandoCreacionSolicitud = false
          }
        } else {
          this.enviarAlertaError({
            mensaje: result.data.Modelo.Mensaje || result.data.Mensaje,
            tiempo: ALERTA_ERROR.tiempo,
            visibilidad: ALERTA_ERROR.visible,
          })
          this.cargandoCreacionSolicitud = false
        }
      } catch (error) {
        console.error(error)
        this.enviarAlertaError({
          mensaje: ALERTA_ERROR.mensaje,
          tiempo: ALERTA_ERROR.tiempo,
          visibilidad: ALERTA_ERROR.visible,
        })
        this.cargandoCreacionSolicitud = false
      }
    },
    ...mapActions({
      enviarAlertaError: 'alerta/enviarAlertaError',
      enviarAlertaExito: 'alerta/enviarAlertaExito',
      actualizaOTP: 'credito/actualizaOtpFirma',
      setEsOtpFirmaValido: 'credito/setEsOtpFirmaValido',
      setAceptaFirmar: 'credito/setAceptaFirmar',
      setSonTerminosBuroConfirmados: 'credito/setSonTerminosBuroConfirmados',
    }),
  },
}
</script>

<style>
.v-input--selection-controls__input {
  align-self: start;
}
</style>
